import { mapState } from 'vuex'
import FixFluidColGrid from '@/components/fix-fluid-col-grid/fix-fluid-col-grid.vue'
import CourierDetailModal from '@/components/modals/courier-detail-modal/courier-detail-modal.vue'
import { getShortId } from '@/utils/format-strings'
import copyTextMixin from '@/components/mixins/copy-text-mixin'

export default {
  name: 'CollectRouteTask',
  /**   * 
   * copyTextMixin:
   *  -onCopyText
   *  -isShiftPress
   */
  mixins: [copyTextMixin],
  props: {
    routeTaskData: {
      type: Object,
      required: true
    }
  },
  components: {
    FixFluidColGrid,
    CourierDetailModal
  },

  static() {
    return {
      countDownInterval: null
    }
  },

  data() {
    return {
      countDownSec: 0,
      isShowTimer: true
    }
  },

  computed: {
    ...mapState({
      paymentTypes: state => state.sharedData.paymentTypes
    }),

    countDownTime() {
      const secondsAbs = Math.abs(this.countDownSec)
      const minutes = Math.floor(secondsAbs / 60)
      const seconds = secondsAbs - minutes * 60
      const secondsStr = seconds < 10 ? `0${seconds}` : seconds
      return `${this.countDownSec < 0 ? '-' : ''}${minutes}:${secondsStr}`
    },

    getCellStr() {
      return orderCells => {
        const cellsArr = orderCells.split(', ')
        if (cellsArr.length === 1 && !isNaN(cellsArr[0])) {
          return `${cellsArr[0]} ячейка`
        }
        return orderCells
      }
    }
  },

  mounted() {
    this.updateCountDown()
  },

  beforeDestroy() {
    window.clearInterval(this.countDownInterval)
    this.countDownInterval = null
  },
  
  methods: {
    getShortId,

    updateCountDown() {
      if (!this.routeTaskData.collecting_started_at) {
        window.clearInterval(this.countDownInterval)
        this.countDownInterval = null
        this.isShowTimer = false
        return
      }
      this.countDownSec = this.$moment(this.routeTaskData.collecting_started_at)
      .add(this.routeTaskData.time_standard, 'seconds')
      .diff(this.$moment(), 'seconds')
      this.isShowTimer = true
      this.setCountDown()
    },

    setCountDown() {
      window.clearInterval(this.countDownInterval)
      this.countDownInterval = window.setInterval(() => {
        this.countDownSec = this.countDownSec - 1
      }, 1000)
    }
  },

  watch: {
    routeTaskData() {
      this.updateCountDown()
    }
  }
}